import React from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'double-caret';

const originalDimensions = {
    width: 13.127,
    height: 19.691,
};

export const IconDoubleCaret = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'black';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses } = props;
    const classNames = cx(addClasses, 'inline');

    return (
        <svg
            aria-labelledby={iconId}
            className={classNames}
            height={height}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id={iconId}>Double Caret Icon</title>
            <defs>
                <clipPath id="b" clipPathUnits="userSpaceOnUse">
                    <path
                        transform="rotate(90)"
                        fill={fill}
                        fillRule="evenodd"
                        d="M5.517-16.843h13.047V2.848H5.517z"
                    />
                </clipPath>
                <clipPath id="a" clipPathUnits="userSpaceOnUse">
                    <path
                        transform="rotate(-90)"
                        fill={fill}
                        fillRule="evenodd"
                        d="M-18.597-2.922H-5.55v19.691h-13.047z"
                    />
                </clipPath>
            </defs>
            <g
                clipPath="url(#a)"
                transform="rotate(90 7.838 10.76)"
                fill="none"
            >
                <path d="M0 0h24v24H0z" />
                <path
                    fill={fill}
                    d="M9.829 18.277l6.74-5.88a.5.5 0 00.002-.752L9.83 5.728a.5.5 0 00-.83.376V17.9a.5.5 0 00.829.377z"
                />
            </g>
            <g
                clipPath="url(#b)"
                fill="none"
                transform="rotate(-90 5.703 11.14)"
            >
                <path d="M0 0h24v24H0z" />
                <path
                    d="M9.829 18.277l6.74-5.88a.5.5 0 00.002-.752L9.83 5.728a.5.5 0 00-.83.376V17.9a.5.5 0 00.829.377z"
                    fill={fill}
                />
            </g>
        </svg>
    );
};
